"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  z50: "#F7FAFF",
  z100: "#EDF4FF",
  z200: "#DBE8FF",
  z300: "#9CC0FF",
  z400: "#538CEE",
  z500: "#256FEF",
  z600: "#1155CB",
  z700: "#1148A6",
  z800: "#0E3272",
  z900: "#082454"
};